import { DefaultValues } from '@redwoodjs/forms'

import WithFormTag from './WithFormTag/WithFormTag'
import WithoutFormTag from './WithoutFormTag/WithoutFormTag'

type ModalFormProps<T> = {
  mutation?: (data: T) => unknown
  onClose: (data?: T) => unknown
  onSubmit?: (data?: T) => unknown
  defaultValues?: DefaultValues<T>
  children: React.ReactNode
  submitLabel?: string
}

function ModalForm<T>({
  mutation,
  defaultValues,
  children,
  onClose,
  onSubmit,
  submitLabel,
}: ModalFormProps<T>) {
  if (mutation && onSubmit) {
    throw new Error('cannot have mutation and onSubmit')
  }
  if (mutation) {
    return (
      <WithFormTag
        mutation={mutation}
        defaultValues={defaultValues}
        onClose={onClose}
        submitLabel={submitLabel}
      >
        {children}
      </WithFormTag>
    )
  } else {
    return (
      <WithoutFormTag
        onClose={onClose}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
      >
        {children}
      </WithoutFormTag>
    )
  }
}

export default ModalForm
